'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockVisitorRequestFailed = exports.requestBlockVisitor = exports.receivedVisitorBlocked = undefined;
exports.blockVisitorRequestSucceeded = blockVisitorRequestSucceeded;
exports.deleteSucceeded = deleteSucceeded;
exports.fetchBlockedVisitors = fetchBlockedVisitors;
exports.unblockVisitorByBlockId = unblockVisitorByBlockId;
exports.unblockVisitorByChannel = unblockVisitorByChannel;
exports.blockVisitor = blockVisitor;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ChatActions = require('conversations-core/actions/ChatActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _blockVisitorUtils = require('conversations-core/utils/blockVisitorUtils');

var _VisitorBlockTypes = require('conversations-core/constants/VisitorBlockTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var receivedVisitorBlocked = exports.receivedVisitorBlocked = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_VISITOR_BLOCKED, function (channel) {
  return { channel: channel };
});

var requestBlockVisitor = exports.requestBlockVisitor = (0, _reduxActions.createAction)(_ActionTypes2.default.BLOCK_VISITOR);

var blockVisitorRequestSucceededAction = (0, _reduxActions.createAction)(_ActionTypes2.default.BLOCK_VISITOR_REQUEST_SUCCEEDED);

function blockVisitorRequestSucceeded(_ref) {
  var channel = _ref.channel,
      blockedVisitor = _ref.blockedVisitor;

  return function (dispatch) {
    dispatch((0, _ChatActions.selectNextChannelForStatus)(channel));
    dispatch(blockVisitorRequestSucceededAction({ channel: channel, blockedVisitor: blockedVisitor }));
  };
}

var blockVisitorRequestFailed = exports.blockVisitorRequestFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.BLOCK_VISITOR_REQUEST_FAILED);

var requestDelete = (0, _reduxActions.createAction)(_ActionTypes2.default.DELETE_BLOCKED_VISITOR);

var deleteSucceededAction = (0, _reduxActions.createAction)(_ActionTypes2.default.DELETE_BLOCKED_VISITOR_SUCCEEDED);

function deleteSucceeded(_ref2) {
  var channel = _ref2.channel,
      blockId = _ref2.blockId;

  return function (dispatch) {
    dispatch((0, _ChatActions.selectNextChannelForStatus)(channel));
    dispatch(deleteSucceededAction({ channel: channel, blockId: blockId }));
  };
}

var deleteFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.DELETE_BLOCKED_VISITOR_FAILED);

var fetchFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.FETCH_BLOCKED_VISITORS_FAILED);

var fetchSucceeded = (0, _reduxActions.createAction)(_ActionTypes2.default.FETCH_BLOCKED_VISITORS_SUCCEEDED);

var requestedBlockVisitors = (0, _reduxActions.createAction)(_ActionTypes2.default.FETCH_BLOCKED_VISITORS);

function fetchBlockedVisitors() {
  return function (dispatch) {
    dispatch(requestedBlockVisitors());
    (0, _MessagesClient.fetchAllBlockedVisitors)().then(function (blockedVisitors) {
      return dispatch(fetchSucceeded(blockedVisitors));
    }, function () {
      return dispatch(fetchFailed());
    }).done();
  };
}

function unblockVisitorByBlockId(blockId) {
  return function (dispatch, getState) {
    var channelForId = (0, _blockVisitorUtils.getChannelForBlockId)(getState(), blockId);
    dispatch(requestDelete());
    (0, _MessagesClient.deleteBlockedVisitorById)(blockId).then(function () {
      return dispatch(deleteSucceeded({ blockId: blockId, channel: channelForId }));
    }, function () {
      return dispatch(deleteFailed());
    }).done();
  };
}

function unblockVisitorByChannel(channel) {
  return function (dispatch) {
    dispatch(requestDelete());
    (0, _MessagesClient.deleteBlockedVisitorByChannel)(channel).then(function () {
      return dispatch(deleteSucceeded({ channel: channel, blockId: null }));
    }, function () {
      return dispatch(deleteFailed());
    }).done();
  };
}

function blockVisitor(_ref3) {
  var reason = _ref3.reason,
      type = _ref3.type;

  return function (dispatch, getState) {
    var _getState = getState(),
        currentChannel = _getState.currentChannel;

    var ipBlock = type === _VisitorBlockTypes.IP;

    dispatch(requestBlockVisitor());
    dispatch((0, _PubNubPresenceActions.leaveChannel)(currentChannel));
    (0, _MessagesClient.blockVisitorByChannel)(currentChannel, reason, ipBlock).then(function (blockedVisitor) {
      return dispatch(blockVisitorRequestSucceeded({
        channel: currentChannel,
        blockedVisitor: blockedVisitor
      }));
    }, function () {
      return dispatch(blockVisitorRequestFailed());
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/VisitorBlockActions.js
// module id = 475
// module chunks = 0